import React from 'react';
import Skeleton from './Skeleton';

type SkeletonCategoryProps = {
    span: number;
};

const SkeletonCategory = ({ span }: SkeletonCategoryProps): JSX.Element => (
    <div className={`table-skeleton-category table-skeleton-category-span-${span}`}>
        <span className="table-skeleton-category-label" />
    </div>
);

type TableSkeletonProps = {
    columns?: number;
    rows?: number;
    sections?: number;
};

const TableSkeleton = ({ columns = 4, rows = 8, sections = 3 }: TableSkeletonProps): JSX.Element => {
    // Distribute columns across sections roughly evenly
    const sectionCols: number[] = [];
    const base = Math.floor(columns / sections);
    let remainder = columns % sections;
    for (let i = 0; i < sections; i++) {
        sectionCols.push(base + (remainder > 0 ? 1 : 0));
        if (remainder > 0) remainder--;
    }

    return (
        <div className="table-skeleton">
            <div className="table-skeleton-stats">
                <Skeleton
                    width="180px"
                    height={16}
                />
            </div>
            <div className="table-skeleton-categories">
                {sectionCols.map((span, i) => (
                    <SkeletonCategory
                        key={`cat-${i}`}
                        span={span}
                    />
                ))}
            </div>
            <div className="table-skeleton-col-labels">
                {Array.from({ length: columns }).map((_, i) => (
                    <div
                        key={`lbl-${i}`}
                        className="table-skeleton-col-label"
                    >
                        <Skeleton
                            width={`${50 + Math.random() * 40}%`}
                            height={12}
                        />
                    </div>
                ))}
            </div>
            <div className="table-skeleton-filter">
                {Array.from({ length: columns }).map((_, i) => (
                    <div
                        key={`flt-${i}`}
                        className="table-skeleton-filter-cell"
                    >
                        <Skeleton
                            width="90%"
                            height={24}
                        />
                    </div>
                ))}
            </div>
            {Array.from({ length: rows }).map((_, rowIdx) => (
                <div
                    key={`row-${rowIdx}`}
                    className={`table-skeleton-row${rowIdx % 2 === 0 ? ' shaded' : ''}`}
                >
                    {Array.from({ length: columns }).map((_, colIdx) => (
                        <div
                            key={`cell-${rowIdx}-${colIdx}`}
                            className="table-skeleton-cell"
                        >
                            <Skeleton
                                width={`${40 + Math.random() * 50}%`}
                                height={12}
                            />
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default TableSkeleton;
